import { render, staticRenderFns } from "./lexile.vue?vue&type=template&id=133d15ee&scoped=true&"
import script from "./lexile.vue?vue&type=script&lang=ts&"
export * from "./lexile.vue?vue&type=script&lang=ts&"
import style0 from "./lexile.vue?vue&type=style&index=0&id=133d15ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d15ee",
  null
  
)

export default component.exports